import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getUser = async () => {
  const { data, error } = await supabase.auth.getUser()

  if (error) {
    throw new Error(error.message)
  }

  if (!data) {
    throw new Error('User not found')
  }

  return data
}

export default function useUser(isAuth: boolean = true) {
  const data = useQuery({
    queryKey: ['user'],
    queryFn: getUser,
    enabled: isAuth,
    staleTime: 1000,
  })
  return {
    ...data,
    isAuth: data?.data?.user?.aud === 'authenticated',
  }
}
